import { StorageBase } from './storage-basic';

export const storage = new StorageBase(window.localStorage);
